import { Component } from '@angular/core';

@Component({
  selector: 'app-copy-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './copy-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class CopyIconComponent {}
